module.exports = __webpack_public_path__ + "static/img/WM799-PF_A.78bd2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WM799-PF_A.jpg
// module id = YDyz
// module chunks = 0